import { Button, Close, Resend } from '@core/ui';
import { kickSpeaker, notifySpeaker, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { Trans, useTranslation } from 'react-i18next';
import { SpeakerStatusBadge } from './SpeakerStatusBadge';

// Pinned "Sprekers" status group shown above the Online participant list in the studio (Moderator/
// Broadcaster) views. Hidden entirely when there are no speakers (spec 8e).
export const SpeakerListRows = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const speakers = useAppSelector((state) => state.liveWebinar.speakers);
    const participants = useAppSelector((state) => state.liveWebinar.participants);

    if (speakers.length === 0) {
        return null;
    }

    return (
        <div className="mb-4">
            <p className="bg-accent-light rounded-lg mb-2 p-2">{t('Speaker.List.Heading', { count: speakers.length })}</p>
            <ul>
                {speakers.map((speaker) => {
                    const participant = participants.find((p) => p.participantId === speaker.participantId);
                    const name = participant?.nickname || speaker.participantId;

                    return (
                        <li key={speaker.participantId} className="flex items-center gap-2 rounded-lg mt-2 mb-1 px-2 py-1">
                            <span className="flex-1 truncate">{name}</span>
                            <SpeakerStatusBadge status={speaker.status} />
                            <Button type="button" onClick={() => dispatch(notifySpeaker(speaker.participantId))} iconbtn>
                                <Resend classNames="size-6 stroke-primary" />
                                <span className="sr-only">
                                    <Trans values={{ name }} i18nKey="Speaker.List.Button.Notify" />
                                </span>
                            </Button>
                            <Button type="button" onClick={() => dispatch(kickSpeaker(speaker.participantId))} iconbtn>
                                <Close classNames="size-6 stroke-warning" />
                                <span className="sr-only">
                                    <Trans values={{ name }} i18nKey="Speaker.List.Button.Kick" />
                                </span>
                            </Button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
